function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Spin, Select, Divider, Space } from "antd";
import { Eyedropper } from 'react-bootstrap-icons';
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;

var LaboForm = function LaboForm(_ref) {
  var handler = _ref.handler,
      customer = _ref.customer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      successMessage = _useState4[0],
      setSuccessMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setSuccessMessage('');
    setErrorMessage('');
    axios.post(Common.baseApiUrl + 'setlaboresult', {
      group: values.group,
      rhesus: values.rhesus,
      user_id: Common.currentUser.id,
      customer_id: customer.id.toString()
    }).then(function (response) {
      setIsFormProcessing(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      group: 'A',
      rhesus: '+'
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "cool-radius",
      children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h5", {
        children: [/*#__PURE__*/_jsx(Eyedropper, {
          size: 30
        }), "LABORATOIRE"]
      }), successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "success",
        message: successMessage
      }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
        type: "error",
        message: errorMessage
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Form, {
        form: form,
        onFinish: onFinish,
        layout: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "group",
          label: "Groupe Sanguin",
          rules: [{
            required: true,
            message: ' Veuillez remplir le groupe sanguin'
          }],
          children: /*#__PURE__*/_jsxs(Select, {
            children: [/*#__PURE__*/_jsx(Option, {
              value: "A",
              children: "A"
            }), /*#__PURE__*/_jsx(Option, {
              value: "B",
              children: "B"
            }), /*#__PURE__*/_jsx(Option, {
              value: "AB",
              children: "AB"
            }), /*#__PURE__*/_jsx(Option, {
              value: "O",
              children: "O"
            })]
          })
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "rhesus",
          label: "Facteur rh\xE9sus",
          rules: [{
            required: true,
            message: ' Veuillez remplir le facteur rhesus'
          }],
          children: /*#__PURE__*/_jsxs(Select, {
            children: [/*#__PURE__*/_jsx(Option, {
              value: "+",
              children: "Positif"
            }), /*#__PURE__*/_jsx(Option, {
              value: "-",
              children: "N\xE9gatif"
            })]
          })
        }), /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              htmlType: "submit",
              children: "Envoyer"
            })
          }), isFormProcessing && /*#__PURE__*/_jsx(Spin, {})]
        })]
      })]
    })
  });
};

export default LaboForm;